import { render, staticRenderFns } from "./DashboardLayoutAXB.vue?vue&type=template&id=89eda7ea&scoped=true&"
import script from "./DashboardLayoutAXB.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutAXB.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutAXB.vue?vue&type=style&index=0&id=89eda7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eda7ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VImg,VList,VListItem,VMenu,VRow,VTooltip})
